/* eslint-disable */
export default {
  confirmationInfo:
    'Uw niet-opgeslagen bewerkingen van de vorige oproep gaan verloren. Weet u zeker dat u aan de nieuwe oproep wilt werken?',
  log: 'Lijst',
  save: 'Opslaan en aan nieuwe werken',
  discard: 'Weggooien en aan nieuwe werken',
  stay: 'Blijven bij vorig werk',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
